import axiosInstance from "./axiosInstance";

export const signUpApi = async (formData) => {
  console.log("i am here ");
  const { data } = await axiosInstance.post("/auth/register", formData);

  return data;
};

export const login = async (formData) => {
  const { data } = await axiosInstance.post("/auth/login", formData);

  return data;
};


export const getOtp = async (email) => {
  console.log("in login");

  const { data } = await axiosInstance.post("/auth/forgot-password", { email });

  return data;
};

export const resetPassword = async (token, password) => {
  const { data } = await axiosInstance.post("/auth/reset-password/" + token, {
    newPassword: password,
  });

  return data;
};
